/* eslint-disable no-lone-blocks */
import React from "react";
import LandingPageLayout from "../../components/landingPageLayout";
import blog1 from "../../assets/images/first_blog.jpg";
import blog2 from "../../assets/images/secblog.jpg";
import blog3 from "../../assets/images/thirdblog.jpg";
import styles from "../blogs/blog.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { MdCalendarMonth } from "react-icons/md";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export const blogData = [
  {
    imgSrc: blog2,
    date: "01/20/2024",
    title:
      "A Deep Dive into New Jersey's Privatization of Construction Code Inspections",
    content:
      "A Deep Dive into New Jersey's Privatization of Construction Code Inspections",
  },
  {
    imgSrc: blog1,
    date: "01/24/2024",
    title:
      "Revolutionize Your Construction Inspections: Discover the Insiders' Shortcut to Effortless, Certified, and Transparent Success",
    content:
      "Completing a construction project requires meticulous planning and efficient coordination. ",
  },
  {
    imgSrc: blog3,
    date: "01/26/2024",
    title:
      "Unlocking Township Success:The Advantages of Privatized Construction Code Inspection",
    content:
      "With the signing of Assembly Bill 573, Townships find themselves at a crossroads with the option to embrace privatized construction",
  },

  // Add other blog objects here with their respective details
];
const Blog = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check for screen size on component mount
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <LandingPageLayout>
      <>
        <div className={styles.blogWrapper}>
          <div className={styles.blogContent}>
            <div className={styles.blogHeader}>
              <h1>Latest News Updates</h1>
            </div>
            {/* <p>
              Create or Manage your inspections with Construction Inspection
              Doctor, all of your data in one place.
            </p> */}
          </div>
        </div>

        <Container>
          <div className={styles.blogs_main}>
            {blogData.map((item, index) => {
              return (
                <>
                  <div
                    onClick={() => {
                      navigate(`/blog/${index + 1}`, { state: item });
                    }}
                    className={styles.blogSection}
                  >
                    <div>
                      {" "}
                      <img src={item.imgSrc} alt="" />
                    </div>
                    <div className={styles.blogContentText}>
                      <div>
                        <h5>{item.title}</h5>
                      </div>
                      <p>{item.content}</p>
                      <div className={styles.date}>
                        {" "}
                        <MdCalendarMonth />
                        <span>{item.date}</span>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </Container>
      </>
    </LandingPageLayout>
  );
};

export default Blog;
